import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.1489 7.5H11.3332C11.057 7.5 10.8332 7.27614 10.8332 7V2.27639C10.8332 1.78168 10.1916 1.58742 9.91715 1.99904L3.43474 11.7226C3.21322 12.0549 3.45141 12.5 3.85076 12.5H8.6665C8.94265 12.5 9.1665 12.7239 9.1665 13V17.7236C9.1665 18.2183 9.80812 18.4126 10.0825 18.001L16.5649 8.27735C16.7865 7.94507 16.5483 7.5 16.1489 7.5Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }